import React from 'react';
import heroImage from '../assets/images/hero.jpg';
import ballroomImage from '../assets/images/ballroom.jpg';

const About = () => {
  return (
    <div className="w-full pt-20">
      {/* Header */}
      <div className="bg-stone-900 text-white py-20 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <img src={heroImage} alt="Background" className="w-full h-full object-cover" />
        </div>
        <div className="relative z-10 container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">Tentang Kami</h1>
          <p className="text-xl text-gray-300">Mengenal lebih dekat Nawasena Garden Resto & Ballroom</p>
        </div>
      </div>

      {/* Story Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="w-full md:w-1/2">
              <img src={ballroomImage} alt="Interior" className="w-full h-[500px] object-cover rounded-2xl shadow-xl" />
            </div>
            <div className="w-full md:w-1/2">
              <h2 className="text-emerald-600 font-medium tracking-widest uppercase mb-2">Cerita Kami</h2>
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-6">
                Menghadirkan Kehangatan dalam Setiap Hidangan
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Nawasena, yang berarti "masa depan yang cerah" dalam bahasa Sanskerta, adalah wujud impian kami untuk menciptakan tempat di mana setiap orang dapat berkumpul, berbagi cerita, dan menikmati hidangan lezat dalam suasana yang menenangkan.
              </p>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Terletak di tengah kota namun menawarkan ketenangan taman yang asri, kami memadukan cita rasa autentik Nusantara dengan sentuhan modern Western. Setiap hidangan kami siapkan dengan bahan-bahan segar pilihan untuk memastikan kualitas rasa terbaik bagi Anda.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div>
                  <h4 className="text-4xl font-serif font-bold text-emerald-600 mb-2">50+</h4>
                  <p className="text-gray-500">Menu Pilihan</p>
                </div>
                <div>
                  <h4 className="text-4xl font-serif font-bold text-emerald-600 mb-2">500+</h4>
                  <p className="text-gray-500">Kapasitas Ballroom</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Mission */}
      <section className="py-20 bg-stone-100">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12">Visi & Misi</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <h3 className="text-xl font-bold text-emerald-800 mb-4">Visi</h3>
              <p className="text-gray-600">
                Menjadi destinasi kuliner dan acara pilihan utama yang dikenal akan kualitas rasa, pelayanan hangat, dan suasana yang tak terlupakan.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <h3 className="text-xl font-bold text-emerald-800 mb-4">Misi</h3>
              <p className="text-gray-600">
                Menyajikan hidangan berkualitas tinggi, memberikan pelayanan profesional yang ramah, dan menyediakan fasilitas terbaik untuk kenyamanan setiap tamu.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
